import { HubSection, HubSectionType } from '@alucio/aws-beacon-amplify/src/models';
import { getNormalizedPageSettingOverrides } from 'src/utils/hiddenSlides';

export const getHubSectionsWithNormalizedHiddenSlidePageSettings = (
  hubSections: HubSection[],
): HubSection[] => hubSections.map(hubSection => {
  if (hubSection.type !== HubSectionType.SHARED_FILES || !hubSection.sharedFiles?.length) {
    return hubSection;
  }

  return {
    ...hubSection,
    sharedFiles: hubSection.sharedFiles.map(sharedFile => ({
      ...sharedFile,
      pageSettings: getNormalizedPageSettingOverrides(sharedFile.pageSettings),
    })),
  };
});
